import React from 'react';
import { SimpleGrid, Card, Image, Text, Button, Title, Box } from '@mantine/core';
import { appConfig } from '../../data/AppConfig';
import draftKingsLogo from '../../assets/partners/draftkings.png';
import fanDuelLogo from '../../assets/partners/fanduel.png';
import kalshiLogo from '../../assets/partners/kalshi.png';
import aristocratLogo from '../../assets/partners/aristocrat.png';
import playmakerLogo from '../../assets/partners/playmaker.png';
import tgifLogo from '../../assets/partners/tgif.svg';
import headbandLogo from '../../assets/partners/headband-logo-light.png';
import geniusLogo from '../../assets/partners/genius.webp';
import bwwLogo from '../../assets/partners/bww.png';

const DEMO_PARTNERS = [
    { id: 'draftkings', name: 'DraftKings', token: 'xK9mP2r5', logo: draftKingsLogo, accentColor: '#53d337', logoBg: '#fff' },
    { id: 'fanduel', name: 'FanDuel', token: 'tR4vN8j2', logo: fanDuelLogo, accentColor: '#1493ff', logoBg: '#fff' },
    { id: 'kalshi', name: 'Kalshi', token: 'wQ6jL1n9', logo: kalshiLogo, accentColor: 'rgb(40, 204, 149)', logoBg: '#fff' },
    { id: 'aristocrat', name: 'Aristocrat', token: 'mV3xQ7wL', logo: aristocratLogo, accentColor: '#786DFF', logoBg: '#786DFF' },
    { id: 'playmaker', name: 'Playmaker', token: 'pK7mB3xR', logo: playmakerLogo, accentColor: '#57c8e6', logoBg: '#0a1a2f' },
    { id: 'tgif', name: 'TGI Fridays', token: 'gF8wT3rY', logo: tgifLogo, accentColor: '#E11932', logoBg: '#fff' },
    { id: 'hdbnd', name: 'HDBND', token: 'hB2nD9xK', logo: headbandLogo, accentColor: '#0e0e10', logoBg: '#0e0e10' },
    { id: 'genius', name: 'Genius Sports', token: 'gN5sP4kQ', logo: geniusLogo, accentColor: '#1E22FF', logoBg: '#fff' },
    { id: 'bww', name: 'Buffalo Wild Wings', token: 'bW7xK2nQ', logo: bwwLogo, accentColor: '#FFC72C', logoBg: '#fff' },
] as const;

const Demos: React.FC = () => {
    const handleLaunch = (token: string) => {
        const base = (appConfig.REACT_APP_BACKEND_URL ?? '').replace(/\/$/, '');
        window.open(`${base}/demo/${token}`, '_blank');
    };

    return (
        <Box>
            <Title order={2} mb="xl">
                Demos
            </Title>
            <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="lg">
                {DEMO_PARTNERS.map(partner => (
                    <Card key={partner.id} shadow="sm" padding="lg" radius="md" withBorder style={{ display: 'flex', flexDirection: 'column' }}>
                        <Card.Section
                            style={{
                                backgroundColor: partner.logoBg,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '32px 24px',
                                borderBottom: `3px solid ${partner.accentColor}`,
                            }}
                        >
                            <Image src={partner.logo} alt={partner.name} h={56} fit="contain" />
                        </Card.Section>
                        <Text fw={600} size="lg" mt="md" mb="xs">
                            {partner.name}
                        </Text>
                        <Button
                            mt="auto"
                            fullWidth
                            style={{ backgroundColor: partner.accentColor, color: '#fff' }}
                            onClick={() => handleLaunch(partner.token)}
                        >
                            Launch
                        </Button>
                    </Card>
                ))}
            </SimpleGrid>
        </Box>
    );
};

export default Demos;
